<template>
  <div id="comp-carrinho-compra" v-if="pedidos.length > 0">
    <div class="d-flex align-center">
      <v-menu offset-y open-on-hover :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
          <span
            v-bind="attrs"
            v-on="on"
            class="font-15 font-weight-medium cursor-help mr-2"
            v-text="`${pedidos.length} pedido${pedidos.length > 1 ? 's' : ''}`"
          />
        </template>

        <v-list>
          <span class="font-12 text-gray-100 pl-2">Pedido{{ pedidos.length > 1 ? 's' : '' }}</span>
          <v-list-item-content v-for="pedido in pedidos" :key="pedido.idpedido" class="px-2">
            <v-list-item-title>
              <span v-text="`Pedido de número ${pedido.idpedido}`" class="font-14 font-weight-medium" />
            </v-list-item-title>

            <v-list-item-subtitle class="font-12">
              <span class="text--primary">Detalhes</span> &mdash;
              pedido aberto por
              <span class="font-weight-medium" v-text="pedido.usuario" />
              em {{ pedido.data_emissao }}
              <template v-if="pedido.status === 'CT'">
                e em cotação desde {{ pedido.inicio_cotacao }}
              </template>
              com {{pedido.total_itens}} produto{{ pedido.total_itens > 1 ? 's' : ''}}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list>
      </v-menu>

      <v-btn color="#A51B32" @click="abrirDialog" dark small>
        <span>CARRINHO</span>
        <span class="qtde-top-button-small" v-text="qtd_produtos_no_carrinho" />
      </v-btn>
    </div>

    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
      persistent
    >
      <v-card tile>
        <div id="titulo-dialog" class="df">
          <v-btn icon dark @click="fecharDialog" class="mt-2">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <titulo-carrinho
            :pedidoSelecionadoProp="pedidoSelecionado"
            :exportar_alteracao_para_erp="exportar_alteracao_para_erp"
            :produtoInvalidoParaExportacao="produtoInvalidoParaExportacao"
            :produtos_pedido="produtos_pedido"
            :exportacao_sankha="exportacao_sankha"
            :pedidos_compras="pedidos"
            class="ml-5 width-100"
            @atualizarPedidos="() => atualizarPedidos++"
          />
        </div>

        <tabela-produtos-comprar
          class="mt-n10px"
          :dialog_carrinho_aberto="dialog"
          :buscarProdutos="dialog"
          :pedidosProp="pedidos"
          :atualizarPedidos="atualizarPedidos"
          :ativarCompraOportunidade="compraOportunidade"
          :valorPedidoMinimoCompra="alertPedidoMinimoCompra"
          @pedidoSelecionado="pedidoSelecionado = $event"
          @atualizarProdutosCompra="atualizarProdutosCompra"
          @click:exportar-alteracao-erp="() => exportar_alteracao_para_erp++"
          @produto-invalido-para-exportacao="produtoInvalidoParaExportacao = $event"
          @produtos-pedido="produtos_pedido = $event"
          @sankhya:resultado-exclusao-produto="exportacao_sankha.exclusao_produto = $event"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CarrinhoAPI from "./../../../api/carrinho";
import tituloCarrinho from "./TituloCarrinho";
import tabelaProdutosComprar from "./TabelaProdutosComprar";

export default {
  props: ["buscarPedidos"],
  components: {
    tituloCarrinho,
    tabelaProdutosComprar,
  },
  data: () => ({
    dialog: false,
    pedidos: [],
    compraOportunidade: "",
    atualizarPedidos: 0,
    pedidoSelecionado: {},
    exportar_alteracao_para_erp: 0,
    alertPedidoMinimoCompra: "",
    produtoInvalidoParaExportacao: false,
    qtd_produtos_no_carrinho: 0,
    produtos_pedido: [],
    exportacao_sankha: {
      exclusao_produto: {}
    }
  }),
  created() {
    this.verificarPedido();
  },
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
      filialCompra: "usuario/getFilialCompras",
      fornecedor: "fornecedor/getFornecedor",
      activityLog: "activityLog/getLog",
      COMPRA_DISTRIBUIDA_POR_FILIAL: "CompraDistribuidaPorFilial/get_distribuir_por_filial"
    }),
    idsPedidosLinha () {
      if (!this.pedidos || this.pedidos.length === 0) {
        return ''
      }
      return this.Helpers.arrayColumn(this.pedidos, 'idpedido').join(', ')
    }
  },
  watch: {
    grupoCompra: function () {
      this.verificarPedido();
    },
    filialCompra: function () {
      this.verificarPedido();
    },
    fornecedor: function () {
      this.verificarPedido();
    },
    buscarPedidos: function () {
      this.verificarPedido();
    },
    pedidoSelecionado: function () {
      this.verificarPedido();
    },
    activityLog() {
      const FUNCTION = this.activityLog.function;

      if (FUNCTION === "getPedidoGrupo") {
        this.abrirDialog();
      }
    },
    COMPRA_DISTRIBUIDA_POR_FILIAL() {
      this.verificarPedido();
    }
  },
  methods: {
    abrirDialog: function () {
      this.dialog = true;
    },
    fecharDialog: function () {
      this.dialog = false;
    },
    atualizarProdutosCompra: function () {
      this.$emit("atualizarProdutosCompra");
    },
    verificarPedido() {
      const headers = this.Helpers.iniciarRequisicao();
      let usuario_id = localStorage.getItem("id");

      const params = {
        fornecedor: this.fornecedor.id,
        grupo: this.grupoCompra,
        filial: this.filialCompra,
        usuario: parseInt(usuario_id),
        analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores,
        compra_por_filial: (this.COMPRA_DISTRIBUIDA_POR_FILIAL && parseInt(this.filialCompra) === 0) ? 'S' : 'N'
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CarrinhoAPI.verificarPedidoGrupo(headers, params)
          .then((response) => {
            const {token, pedido, qtd_produtos, compra_oportunidade, fornecedor_pedido_minimo} = response.data;
            localStorage.setItem("token", token);

            this.pedidos = pedido;
            this.qtd_produtos_no_carrinho = qtd_produtos;
            this.compraOportunidade = compra_oportunidade;
            this.$emit("compraOportunidade", this.compraOportunidade);

            if (fornecedor_pedido_minimo.length > 0) {
              this.alertPedidoMinimoCompra = fornecedor_pedido_minimo[0].pedido_minino_compra;
            }

            if (!this.pedidos[0]) {
              this.fecharDialog();
            }
          })
          .catch(() => this.Helpers.logout())
      );
    },
  },
};
</script>

<style scoped>
#titulo-dialog {
  background: #042333;
  color: #fff;
  padding: 8px;
}
.cor-branca {
  color: #fff;
}
.mt-n10px {
  margin-top: -10px;
}
</style>

<style>
.div-center {
  margin-left: auto;
  margin-right: auto;
  padding-left: 0;
  padding-right: 0;
}
.df {
  display: flex;
}
.ta-center {
  text-align: center;
}
.ta-right {
  text-align: right;
}
.ta-left {
  text-align: left;
}
.width-100 {
  width: 100%;
}
</style>

